"use strict";

exports.__esModule = true;
var metadata = {
  stage: 2
};
exports.metadata = metadata;


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/lib/transformation/transformers/es7/trailing-function-commas.js
// module id = 2114
// module chunks = 0